document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.custom-megamenu').forEach(menuElement => {
        let menu = menuElement.dataset.menu;
        console.log(document.querySelector(`.child-megamenu-wp[data-type="${menu}"]`).innerHTML);
        document.querySelector(`.child-megamenu-wp[data-type="${menu}"]`).innerHTML = menuElement.innerHTML;
        document.querySelector(`.cmdn-accordion-content[data-type="${menu}"]`).innerHTML = menuElement.innerHTML;
    });
  document.querySelectorAll('.cmc-tabswp').forEach((tabswp) => {
      const tabTriggers = tabswp.querySelectorAll('.cmc-tab-trigger');
      const tabContents = tabswp.querySelectorAll('.cmc-tabs-content');    
  
      tabTriggers.forEach((trigger) => {
          trigger.addEventListener('mouseenter', (event) => {
              tabTriggers.forEach((tabTrigger) => tabTrigger.classList.remove('tab_active'));
              tabContents.forEach((content) => content.classList.remove('tab_active'));
  
              const dataTab = event.target.dataset.tab;
              event.target.classList.add('tab_active');
              tabswp.querySelector(`#${dataTab}`).classList.add('tab_active');
          });
      });  
  });
document.querySelectorAll('.cmc-enbslider').forEach((slider) => {
const flickityInstance = new Flickity(slider, {
  cellAlign: 'left',
  contain: true,
  pageDots: false,
  wrapAround: true
});
});

document.querySelectorAll('.cmdn-grid').forEach((grid) => {
  const tabTriggers = grid.querySelectorAll('.cmdn-tab-trigger');
  const tabContents = grid.querySelectorAll('.cmdn-tab-content');
  const accordionTriggers = grid.querySelectorAll('.cmdn-accordion-trigger');

  tabTriggers.forEach((trigger) => {
    trigger.addEventListener('mouseenter', (event) => {
      tabTriggers.forEach((el) => el.classList.remove('tab_active'));
      tabContents.forEach((el) => el.classList.remove('tab_active'));

      const targetId = event.target.dataset.tab;
      event.target.classList.add('tab_active');
      const targetContent = grid.querySelector(`#${targetId}`);
      if (targetContent) {
        targetContent.classList.add('tab_active');
      }
    });
  });

accordionTriggers.forEach((trigger) => {
  trigger.addEventListener('click', () => {
    const wrapper = trigger.closest('.cmdn-accordion-wp');
    const content = wrapper.querySelector('.cmdn-accordion-content');
    const isOpen = wrapper.classList.contains('active');

    grid.querySelectorAll('.cmdn-accordion-wp').forEach((acc) => {
      acc.classList.remove('active');
      const accContent = acc.querySelector('.cmdn-accordion-content');
      accContent.style.maxHeight = null;
    });

    if (!isOpen) {
      wrapper.classList.add('active');
      content.style.maxHeight = content.scrollHeight + 'px';
      setTimeout(() => {
        const nav = trigger.closest('.menu-drawer__navigation');
        nav.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
      },200);
    }
  });
});
});


  document.querySelectorAll('.changetext').forEach(elem => {
    elem.addEventListener('mouseenter', () => {
      const newText = elem.getAttribute('data-text');
      if (!newText) return;
  
      const customMenu = elem.closest('.cmc-tabs-content');
      if (!customMenu) return;
  
      const bannerMain = customMenu.querySelector('.shopbanner-main');
      if (!bannerMain) return;
  
      const heading = bannerMain.querySelector('.shopbanner-heading');
      if (heading) {
        heading.textContent = newText;
      }
    });
  });

});